import { rem } from "polished";
import type { SponsorLayout } from "src/types";
import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/use-color";

import {
  CardLogoContainer,
  SponsorCardLogo,
  SponsorCardText,
  StyledSponsorCard,
} from "./sponsor-card/sponsor-card-component-styles";

export const BackgroundColorWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors[ColorLabels.VISUALS_2]};
`;

export const PaddingWrapper = styled.div`
  padding: ${rem(80)} 0;
`;

export const CenteredHeader = styled.div`
  margin-bottom: ${rem(40)};

  .text-primitive.headingTwo {
    text-align: center;
    color: ${({ theme }) => theme.colors[ColorLabels.SECONDARY_FONT]};
  }
`;

export const StyledSponsorsList = withViewportStyle("div")<{
  layout: SponsorLayout;
}>`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;

  ${StyledSponsorCard} {
    width: ${(props) =>
      props.layout === "golden"
        ? rem(392)
        : props.layout === "silver"
        ? rem(288)
        : rem(184)};

    ${(props) => props.$viewport.mobile`
      width: ${(props) =>
        props.layout === "golden"
          ? rem(343)
          : props.layout === "silver"
          ? rem(343)
          : rem(164)};
    `}
  }

  ${CardLogoContainer} {
    padding: ${(props) =>
      props.layout === "golden"
        ? `${rem(8)} ${rem(40)}`
        : props.layout === "silver"
        ? `${rem(8)} ${rem(40)}`
        : `${rem(8)} ${rem(24)}`};
      
    ${(props) => props.$viewport.mobile`
      padding: ${(props) =>
        props.layout === "golden"
          ? `${rem(16)} ${rem(16)}`
          : props.layout === "silver"
          ? `${rem(16)} ${rem(68)}`
          : `${rem(16)} ${rem(16)}`};
    `}
    }

    ${SponsorCardLogo} {
      height: ${(props) =>
        props.layout === "golden"
          ? rem(144)
          : props.layout === "silver"
          ? rem(99)
          : rem(57)};
    }

    ${SponsorCardText} {
      min-height: ${(props) =>
        props.layout === "golden"
          ? rem(72)
          : props.layout === "silver"
          ? rem(56)
          : rem(40)};

      padding: ${(props) =>
        props.layout === "golden"
          ? `0 ${rem(16)}`
          : props.layout === "silver"
          ? `0 ${rem(16)}`
          : `0 ${rem(8)}`};

      ${(props) => props.$viewport.mobile`
        min-height: ${(props) =>
          props.layout === "golden"
            ? rem(56)
            : props.layout === "silver"
            ? rem(56)
            : rem(40)};
            
        padding: ${(props) =>
          props.layout === "golden"
            ? `${rem(16)}`
            : props.layout === "silver"
            ? `${rem(16)}`
            : `${rem(4)} ${rem(8)}`};
      `}
    }
`;
